import { makeStyles } from '@mui/styles';

export const usePageControlsStyles = makeStyles((theme) => ({
  filtersToggle: {
    color: 'rgba(255, 255, 255, 0.7 )',
    padding: '10px 0',
    cursor: 'pointer'
  },
  select: {
    width: '100%',
    background: '#FFFFFF1F',
    height: '40px',
    borderRadius: '4px',
    [theme.breakpoints.up('md')]: {
      width: '12em'
    }
  },
  selectMenu: {
    height: '40px',
    color: '#FFFFFF',
    '&:not(.Mui-focused):hover .MuiOutlinedInput-notchedOutline': {
      borderColor: 'white'
    },
    '& > .MuiSelect-icon': {
      top: 'calc(50% - 10px)',
      color: '#FFFFFF'
    }
  },
  selectLabel: {
    textOverflow: 'ellipsis !important',
    borderRadius: '4px',
    color: '#FFFFFF',
    fontSize: '13px',
    marginTop: '-5px',
    '&.MuiInputLabel-shrink': {
      transform: `translate(14px, -2px) scale(0.75)`
    }
  },
  datePicker: {
    [theme.breakpoints.up('md')]: {
      width: '13em'
    },

    [theme.breakpoints.down('sm')]: {
      flexGrow: 1
    },

    // X Date Pickers v8+ render a section list inside MuiPickers* elements rather
    // than an <input> inside MuiOutlinedInput, so target those classes.
    '& .MuiPickersOutlinedInput-root:hover:not(.Mui-focused) .MuiPickersOutlinedInput-notchedOutline': {
      borderColor: 'white'
    },

    '& .MuiPickersInputBase-root': {
      backgroundColor: '#FFFFFF1F',
      color: 'white',
      paddingLeft: 0
    },

    '& .MuiPickersInputBase-sectionsContainer': {
      height: '40px',
      padding: '0 8px',
      boxSizing: 'border-box',
      alignItems: 'center'
    },

    '& .MuiInputLabel-outlined': {
      textOverflow: 'ellipsis !important',
      color: '#FFFFFF',
      fontSize: '13px',
      marginTop: '-5px'
      // transform: 'translate(14px, 14px) scale(1)'
    },

    '& .MuiInputLabel-shrink': {
      transform: `translate(14px, 0px) scale(0.75)`
    },

    '& label': {
      color: 'white',
      width: '95%'
    }
  },
  datePickerInUse: {
    '& .MuiPickersOutlinedInput-root:not(.Mui-focused) .MuiPickersOutlinedInput-notchedOutline': {
      borderColor: 'white'
    }
  }
}));
